import { Dialog,DialogActions,DialogContent,DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import AttToken from '../../helpers/attToken';
import queryClient from '../../service/query';
import Reports from '../../service/Reports';

type Props = {
    open: boolean;
    setOpen: Function
    toExclude: { user: string, timestamp: number }[] | null
    setToExclude: Function
};
const reportService = new Reports();

export default function ModalExclusion({ open, setOpen, toExclude, setToExclude }: Props) {

    const deleteExecucao = async () => {
        const token = await AttToken();
        if (token && toExclude) {
            const response = await reportService.deleteExecucao(token, toExclude[0].timestamp, toExclude[0].user);
            if (response) {
                setOpen(false);
                setToExclude(null);
                queryClient.refetchQueries({queryKey: ['GET_REPORTS_DATA']});
            }
        }
    };
    return (
        <>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <>
                    <DialogContent >

                        <DialogContentText id="modal-modal-title" variant="h6" component="h2">
                            Formulário não consta em nossa base e será excluido da lista, desculpe pelo transtorno.
                        </DialogContentText>
                        <DialogActions>
                            <Button onClick={() => { deleteExecucao(); }}>Ok</Button>
                        </DialogActions>
                    </DialogContent>
                </>
            </Dialog>
        </>
    );
}